export default function (ctx) {
  if (process.env.NODE_ENV !== 'development') {
    const domain = process.server ? ctx.req.headers.host : window.location.host;
    ctx.$axios.setBaseURL(`https://${domain}`)
  }
}
